import { Component, OnInit } from "@angular/core";
import { DocumentsService } from "../../../../auth/service/documents.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../auth/service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";
import { IDatatableConfig } from "app/auth/models/datatable";
import { IDocument } from "app/auth/models/document-id";

@Component({
  selector: "app-document-list",
  templateUrl: "./staff-assets-document-list.component.html",
  styleUrls: ["./staff-assets-document-list.component.scss"],
})
export class StaffAssetsDocumentListComponent implements OnInit {
  public config: IDatatableConfig;
  public contentHeader: IContentHeader;
  public document: IDocument[];
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public selectedCategory: string = "all";
  public searchStatus: number = 10;
  public me: ICurrentUser;

  constructor(
    public _documentService: DocumentsService,
    public _utilService: UtilsService,
    private _routerService: Router,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
  ) {
    this._utilService.disableAutoHideLoading();
    this.config = {
      selectLimitItems: true,
      headerHeight: 30,
      rowHeight: window.innerWidth > 1440 ? 70 : 100,
      footerHeight: 60,
      scrollbarH: true,
      searchable: false,
      exportable: false,
    };
    this.contentHeader = {
      headerTitle: "MENU.DOCUMENTS_LIST",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.DOCUMENTS_LIST",
            isLink: false,
          },
        ],
      },
    };

    this.activatedRoute.queryParams.subscribe((params) => {
      this.searchKeyword = params.hasOwnProperty("search") ? params.search : "";
    });
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_assets_document")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      this._utilService.hideLoading();
      return false;
    }
    await this.loadDocuments();
    this.me = await this._authenticationService.getCurrentUser();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadDocuments() {
    this.document = await this._documentService.getForAssets();
    this.document.map((item: IDocument) => {
      item.user_data.map((data) => {
        //Array di nomi utenti per filtrarli al meglio in caso di queryParam
        if (data.complete_name && data.complete_name.length > 0) {
          item.user_complete_name = [];
          item.user_complete_name.push(data.complete_name.toLowerCase());
        }
      });
    });
    setTimeout(() => this._utilService.hideLoading());
  }

  documentList() {
    let items: IDocument[] = this.document;
    if (!items) {
      return [];
    }

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: IDocument) => item.title?.toLowerCase().includes(keywords) || item.user_complete_name?.includes(keywords));
    }

    if (this.selectedCategory !== "all") {
      items = items.filter((item: IDocument) => item.category_name?.toLowerCase() === this.selectedCategory.toLowerCase());
    }

    return items;
  }

  async goToDocument(item: IDocument) {
    item.user_data = item.user_data.filter((user) => user.hash);
    //If it doesn't have users we will open the file directly in a new tab
    if ((!item.user_data || item.user_data.length < 1) && item.description) {
      await this._utilService.getFile(item.description);
    } else {
      //If the document has recipients we will open the document staff-view
      await this._routerService.navigateByUrl(`/dashboard/single-document-file/${item.id}?hash=${item.user_data[0].hash}`);
    }
  }
}
